export enum WorkCardTypes {
  PHYSICAL = 'physical',
  DIGITAL = 'digital'
}